<template>
  <div class="tabsPlatform-content">
    <SelectCustom class="selectItem" :options="tabs" v-model="selectedTab" />
    <!-- commit  -->
    <div class="buttonsContainer" ref="buttonsContainer">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        class="buttonItem"
        :class="{ selected: selectedTab === tab.value }"
        @click="selectTab(tab.value)"
      >
        {{ $t(tab.label) }}
      </button>
      <span class="selected-border" :style="borderStyle">
        <div class="border-style"></div>
      </span>
    </div>
    <div class="card-content">
      <div class="subTabContainer">
        <button
          v-for="subTab in selectedSubTabs"
          :key="subTab.value"
          class="subTabButton"
          :class="{ selected: selectedSubTab === subTab }"
          @click="selectSubTab(subTab)"
        >
          {{ $t(subTab.label) }}
        </button>
      </div>
      <div class="subTabContent">
        <div v-if="selectedSubTab">
          <div class="accordeon">
            <div class="accordeon-box">
              <div
                v-for="(item, index) in selectedSubTab.items"
                :key="index"
                class="box"
                :class="activeIndex === index ? 'activeOption' : ''"
              >
                <div class="box-content" @click="setActive(index)">
                  <div
                    class="box-icon"
                    v-if="item.icon && activeIndex === index"
                    :class="[item.specialClass]"
                  >
                    <div class="icon">
                      <span class="material-symbols-outlined" translate="no">{{
                        item.icon
                      }}</span>
                    </div>
                  </div>
                  <div class="box-text">
                    <p class="title body-6">{{ $t(item.title) }}</p>
                    <p class="body-4" v-if="activeIndex === index">
                      {{ $t(item.text) }}
                    </p>
                  </div>
                  <div class="arrow">
                    <span
                      class="material-symbols-outlined"
                      v-if="activeIndex != index"
                      >expand_more</span
                    >
                    <span
                      class="material-symbols-outlined"
                      v-if="activeIndex === index"
                      >expand_less</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <iframe
        v-if="showIframe && iframeOptions"
        :src="iframeOptions.src"
        :width="iframeOptions.width"
        :height="iframeOptions.height"
        :frameborder="iframeOptions.frameborder"
        :allowfullscreen="iframeOptions.allowfullscreen"
      ></iframe>
    </div>
  </div>
</template>

<script>
import SelectCustom from "../components/utils/select/SelectCustom.vue";
import { ref } from "vue";

export default {
  name: "Tabs y accordeones",
  components: {
    SelectCustom,
  },
  props: {
    tabs: Array,
    categories: Object,
    subTabs: Object,
    options: Object,
    showIframe: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const activeIndex = ref(0);

    const setActive = (index) => {
      activeIndex.value = index;
    };

    return {
      activeIndex,
      setActive,
    };
  },
  data() {
    return {
      selectedTab: null,
      selectedSubTab: null,
      selectedButtonIndex: 0,
      borderStyle: {},
      selected: null,
      iframeOptions: null, // <-- AÑADIR ESTA LÍNEA
    };
  },
  mounted() {
    this.initializeBorderBottomStyle();
    this.selectTab(
      this.selectedTab || (this.tabs.length > 0 ? this.tabs[0].value : null)
    );
  },
  computed: {
    selectedSubTabs() {
      return this.categories[this.selectedTab]
        ? this.categories[this.selectedTab][0].subTabs
        : [];
    },
  },
  watch: {
    selectedTab: {
      immediate: true,
      handler(newTab) {
        if (!newTab) return; // Evitar errores si newTab es nulo al inicio
        this.selectTab(newTab);

        this.$nextTick(() => {
          if (this.selectedSubTabs && this.selectedSubTabs.length > 0) {
            this.selectSubTab(this.selectedSubTabs[0]);
          }
          this.setActive(0);
        });
      },
    },
  },
  methods: {
    handleSelectChange(newTab) {
      this.selectTab(newTab);
      if (this.selectedSubTabs && this.selectedSubTabs.length > 0) {
        this.selectSubTab(this.selectedSubTabs[0]);
      }
      this.setActive(0);
    },
    selectTab(tabName) {
      if (!tabName) return;
      const newIndex = this.tabs.findIndex((tab) => tab.value === tabName);
      if (newIndex !== -1) {
        this.selectedTab = tabName;
        // Asignación segura de subTab
        this.selectedSubTab =
          this.selectedSubTabs && this.selectedSubTabs.length > 0
            ? this.selectedSubTabs[0]
            : null;
        this.selectedButtonIndex = newIndex;
        this.updateBorderBottomStyle();

        const categoryConfig = this.categories[tabName]?.[0];
        if (categoryConfig?.showIframe && categoryConfig.iframeOptions) {
          this.iframeOptions = { ...categoryConfig.iframeOptions };
        } else {
          this.iframeOptions = null;
        }
      }
    },
    showIframeForCategory(category) {
      const categoryConfig = this.categories[category]?.[0];
      return categoryConfig?.showIframe === true;
    },
    selectSubTab(subTab) {
      this.selectedSubTab = subTab;
      this.activeIndex = 0;
      this.setActive(0);
    },
    initializeBorderBottomStyle() {
      if (!this.$refs.buttonsContainer) return;
      const button =
        this.$refs.buttonsContainer.children[this.selectedButtonIndex];
      if (button) {
        this.borderStyle = {
          width: `${button.offsetWidth}px`,
          left: `${button.offsetLeft}px`,
        };
      }
    },
    updateBorderBottomStyle() {
      if (!this.$refs.buttonsContainer) return;
      const button =
        this.$refs.buttonsContainer.children[this.selectedButtonIndex];
      if (button) {
        this.borderStyle = {
          width: `${button.offsetWidth}px`,
          left: `${button.offsetLeft}px`,
        };
      }
    },
  },
};
</script>
